import { Divider, Pagination, Card } from 'antd';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../../methods/redux/hooks';
import { getStakingReport } from '../../../methods/redux/reducers/accountant-report';
import remakeQueryString from '../../../methods/utils/remake-query-string';
import TransactionItem from '../../../transactions/transaction-statments/TransactionItem';
import AccountantsDateSelector from '../DateSelector';
import DownloadCSV from '../DownloadCSV';

const Style = styled(Card)``;

const StakingAccountantReport = () => {
	const dispatch = useAppDispatch();

	const [searchParams, setSearchParams] = useSearchParams();

	const { staking } = useAppSelector((store) => store.accountantsReport);

	const updateQueryString = (query: any, action = 'update') => {
		remakeQueryString(query, searchParams, setSearchParams, action);
	};

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length > 0) {
			dispatch(
				getStakingReport({
					...queryData,
				})
			);
		}
	}, [searchParams]);

	return (
		<Style>
			<h1>Staking Report</h1>

			<Divider />

			<AccountantsDateSelector onGetReport={updateQueryString} />

			{staking.record.itemsList.length > 0 && (
				<>
					<Divider />

					<Pagination
						onChange={(pageId) => updateQueryString({ pageId })}
						total={staking.record.paginator.itemCount}
						current={staking.record.paginator.currentPage}
						pageSize={staking.record.paginator.perPage}
					/>
					<br />

					<div>
						<DownloadCSV title="staking" csv={staking.record?.reportCSVFile} />
					</div>

					<br />

					{staking.record.itemsList.map((item: any) => (
						<TransactionItem key={item._id} transaction={item} />
					))}

					<Divider />
					<Pagination
						onChange={(pageId) => updateQueryString({ pageId })}
						total={staking.record.paginator.itemCount}
						current={staking.record.paginator.currentPage}
						pageSize={staking.record.paginator.perPage}
					/>
				</>
			)}
		</Style>
	);
};

export default StakingAccountantReport;
